import React, { useState, useEffect } from 'react';
import './SubDivisionCreationForGodown.css';
import Select from 'react-select';
import { getAllDistrictBihar } from '../../../services/monthlyAttendanceService';
import { getBlocksBasedOnsubId, getsubdivisionsBasedonDid, saveBlock, saveGodownLocation, saveSubDivision } from '../../../services/godownLatLongService';
import { capitalizeFirstLetter } from '../../../utils/validations';
import { useNavigate } from 'react-router-dom';

const SubDivisionCreationForGodown = () => {
    const [districtOptions, setDistrictOptions] = useState([]);
    const [districtId, setDistrictId] = useState(null);
    const [subDivisionUid, setSubDivisionkUid] = useState(null);
    const [subDivisionName, setSubDivisionName] = useState('');

    const navigate = useNavigate();

    // Fetch Districts
    useEffect(() => {
        const fetchDistricts = async () => {
            try {
                const data = await getAllDistrictBihar();
                const formattedOptions = data.map(item => ({
                    value: item.districtId,
                    label: item.districtName,
                }));
                setDistrictOptions(formattedOptions);
            } catch (err) {
                console.error('Error fetching districts:', err);
            }
        };
        fetchDistricts();
    }, []);

    const handleDistrictChange = (selectedOption) => {
        setDistrictId(selectedOption ? selectedOption.value : null);
    };

    const handleReset = () => {
        setDistrictId(null);
        setSubDivisionName('');
        setSubDivisionkUid('');
    };

    const handleSubmit = async () => {
        if (!subDivisionUid || !subDivisionName) {
            alert("Please fill all fields");
            return;
        }

        const payload = {
            district: {
                districtId: districtId,
            },
            subDivisionUid,
            subDivisionName
        };

        try {
            await saveSubDivision(payload);
            alert("SubDivison saved successfully!");
            handleReset();
        } catch (error) {
            alert("Failed to save SubDivison. Please try again.");
            console.error(error);
        }
    };

    const gotoCreationLatLong = () => {
        navigate("/subDivisionUpdateForGodown");
    };

    return (
        <div className="SubDivision-block-container">
            <div className="SubDivision-form-card">
                <h2 className="SubDivision-form-title">Create Sub Division</h2>
                <div className='SubDivision-navigate-btn'>
                    <button type='button' className='SubDivision-godown-btn-navigate' onClick={gotoCreationLatLong}>Back</button>
                </div>
                <div className="SubDivision-form-grid">
                    {/* Row 1 */}
                    <div className="SubDivision-input-group">
                        <Select
                            className={`SubDivision-custom-select ${districtId ? 'has-value' : ''}`}
                            classNamePrefix="select"
                            placeholder=" "
                            isClearable
                            options={districtOptions}
                            value={districtOptions.find(opt => opt.value === districtId) || null}
                            onChange={handleDistrictChange}
                        />
                        <label> <span className='SubDivision-required'>*</span>District</label>
                    </div>

                    <div className="SubDivision-input-group">
                        {/* Sub Division select - commented out */}
                    </div>

                    <div className="SubDivision-input-group">
                        <input
                            type="number"
                            className="SubDivision-custom-input"
                            placeholder=" "
                            name="blockUid"
                            value={subDivisionUid}
                            onChange={(e) => { setSubDivisionkUid(e.target.value) }}
                        />
                        <label> <span className='SubDivision-required'>*</span>SubDivision UID</label>
                    </div>

                    <div className="SubDivision-input-group">
                        <input
                            type="text"
                            className="SubDivision-custom-input"
                            placeholder=" "
                            name="blockName"
                            value={subDivisionName}
                            onChange={(e) => { setSubDivisionName(e.target.value) }}
                        />
                        <label> <span className='SubDivision-required'>*</span>SubDivision Name</label>
                    </div>
                </div>

                <div className="SubDivision-button-group">
                    <button className="SubDivision-btn SubDivision-btn-primary" onClick={handleSubmit}>Save</button>
                    <button className="SubDivision-btn SubDivision-btn-secondary" onClick={handleReset}>Clear</button>
                </div>
            </div>
        </div>
    );
};

export default SubDivisionCreationForGodown;